const PENDING_KEY = "pai_pending_payments";

export function readPendingPayments() {
  try {
    return JSON.parse(localStorage.getItem(PENDING_KEY) || "[]").filter(Boolean);
  } catch (e) {
    return [];
  }
}

export function writePendingPayments(ids) {
  localStorage.setItem(PENDING_KEY, JSON.stringify([...new Set(ids)].filter(Boolean)));
}

export function addPendingPayment(sessionId) {
  if (!sessionId) return readPendingPayments();
  const next = [...readPendingPayments(), sessionId];
  writePendingPayments(next);
  return readPendingPayments();
}

export function removePendingPayment(sessionId) {
  const next = readPendingPayments().filter((pendingId) => pendingId !== sessionId);
  writePendingPayments(next);
  return next;
}

export function clearPendingPayments() {
  localStorage.removeItem(PENDING_KEY);
}

export async function openCheckoutUrl(
  url,
  {
    isNativePlatform = () => false,
    openNativeBrowser = null,
    assignLocation = (target) => {
      window.location.href = target;
    },
    beforeOpen = null,
    waitForCheckoutHandoff = null,
  } = {}
) {
  if (beforeOpen) beforeOpen();
  if (waitForCheckoutHandoff) await waitForCheckoutHandoff();

  if (isNativePlatform() && openNativeBrowser) {
    try {
      await openNativeBrowser(url);
      return "native";
    } catch (error) {
      console.warn("Native Checkout-Oeffnung fehlgeschlagen:", error);
    }
  }

  assignLocation(url);
  return "web";
}

export function parseCheckoutReturnUrl(url) {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "physikai:" || parsed.hostname !== "payment-return") return null;
    return {
      sessionId: parsed.searchParams.get("session_id"),
      status: parsed.searchParams.get("status") || "success",
    };
  } catch (e) {
    return null;
  }
}
